<template>
  <div class="metric-card">
    <div v-if="!noData" class="metric-card__data" :class="[positiveData ? 'green' : 'red']">
      <img v-if="!positiveData" class="mr-1" src="@/assets/icons/arrow-red-down.svg" alt="arrow-red-down" />
      <img v-if="positiveData" class="mr-1" src="@/assets/icons/arrow-green-up.svg" alt="arrow-green-up" />
      {{ metricData }}%
    </div>
    <div v-else>-</div>
  </div>
</template>

<script>
  export default {
    name: "MetricCard",
    props: {
      metricData: {
        type: [String, Number],
        default: "",
      },
    },
    data() {
      return {
        positiveData: null,
        noData: false,
      };
    },
    mounted() {
      this.noData = this.metricData === "";
      this.positiveData = !this.noData && Number(this.metricData) >= 0;
    },
    methods: {},
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/typography/index.scss";
  @import "@core/preset/preset/functions.scss";
  .metric-card {
    @include text-body-2();
    color: get-color("body");

    &__data {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      &.green {
        color: get-color("success");
      }
      &.red {
        color: get-color("error");
      }
    }
  }
</style>
